//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TheHeader from "./components/TheHeader.vue";
import MobileHeader from "./components/MobileHeader.vue";
import DarkFooter from "./components/DarkFooter.vue";
import AuthenticationPopup from "./components/AuthenticationPopup.vue";
import User from "~/assets/js/User";

export default {
  name: "DefaultLayout",
  middleware: "authenticated",
  components: {
    TheHeader,
    MobileHeader,
    DarkFooter,
    AuthenticationPopup,
  },
  computed: {
    username() {
      return this.$localStore.get("username");
    },
    email() {
      return this.$localStore.get("email");
    },
    path() {
      return this.$nuxt.$route.name;
    },
  },
  methods: {
    signOut() {
      this.$localStore.clearAll();
      this.$cookies.remove("authenticated");
      User.signOut();
      window.location.href = "/";
    },
  },
};
